import { render, staticRenderFns } from "./ChatVideoDetail.vue?vue&type=template&id=19a4e3bc&scoped=true&lang=pug"
import script from "./ChatVideoDetail.vue?vue&type=script&lang=js"
export * from "./ChatVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatVideoDetail.vue?vue&type=style&index=0&id=19a4e3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4e3bc",
  null
  
)

export default component.exports